<template>
    <DsModal
        :is-open="isOpen"
        size="lg"
        class="import-xml-modal"
        @close="closeImportXml"
    >
        <template #heading>
            <DsModalHeader>
                <template #leading>
                    <DsIconButton name="x" @click="closeImportXml" />
                </template>
                <template #title>
                    <DsModalHeaderTitle>
                        <template #title>
                            {{ $t('funnel.edit.debug.import') }}
                        </template>
                    </DsModalHeaderTitle>
                </template>
                <template #trailing>
                    <DsFilledButton data-qa="importXml-button" @click="importXml">
                        {{ $t('funnel.edit.import') }}
                    </DsFilledButton>
                </template>
            </DsModalHeader>
        </template>
        <DsInlineAlert
            leading-icon
            type="warning"
            class="import-warning-message"
        >
            {{ $t('funnel.edit.import.xml.warning') }}
        </DsInlineAlert>
        <codemirror
            v-model="xmlFile"
            class="xml-code"
            :options="codeMirrorOptions"
        />
    </DsModal>
</template>
<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml';

export default {
    components: {
        codemirror,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },
    emits: ['import-xml', 'close-import-xml'],
    data() {
        return {
            xmlFile: '',
            codeMirrorOptions: {
                tabSize: 4,
                theme: 'default',
                mode: 'text/xml',
                lineNumbers: true,
                line: true,
            },
        };
    },

    methods: {
        async importXml() {
            const event = {
                xmlToImport: this.xmlFile,
            };

            this.$emit('import-xml', event);
        },

        closeImportXml() {
            this.$emit('close-import-xml');
        },
    },
};
</script>

<style lang="scss">
    .import-xml-modal {
        div.modal-body {
            padding: 0;
        }
    }

    div.inline-alert.import-warning-message.warning > span {
        font-size: 14px;
    }

    .xml-code {
        width: 750px;
        border: 1px solid $color-gray-200;
        margin-top: $spacing-200;
    }

    div.vue-codemirror.xml-code > div {
        height: 635px;
    }

</style>
